import http from '@/utils/httpClient';
import { toaster } from '@/utils/toast';
import { Thunk, thunk } from 'easy-peasy';

export interface contactForm {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  message: string;
}

export interface IContactModel {
  contactForm: contactForm | undefined;
  sendContactMessage: Thunk<IContactModel, contactForm>;
}

const ContactModel: IContactModel = {
  contactForm: undefined,

  sendContactMessage: thunk(async (_action, payload) => {
    const response = await http()
      .post('/contact-us', payload)
      .then((res) => {
        res.data.message === 'Success' ? toaster('success', 'Message sent') : null;
      })
      .catch((e) => toaster('error', 'Error in sending message'));
    return response;
  }),
};
export default ContactModel;
